export const types = {
  MATERIAL_MODAL_OPEN: 'materialList/MATERIAL_MODAL_OPEN',
  MATERIAL_MODAL_CLOSE: 'materialList/MATERIAL_MODAL_CLOSE',
  MATERIAL_MODAL_SAVE_REQUEST: 'materialList/MATERIAL_MODAL_SAVE_REQUEST',
  MATERIAL_MODAL_SAVE_SUCCESS: 'materialList/MATERIAL_MODAL_SAVE_SUCCESS',
  MATERIAL_MODAL_SAVE_ERROR: 'materialList/MATERIAL_MODAL_SAVE_ERROR',
};

export const materialModal = {
  open: ({ material, supplierMaterial }) => ({
    type: types.MATERIAL_MODAL_OPEN,
    payload: { material, supplierMaterial },
  }),
  close: () => ({
    type: types.MATERIAL_MODAL_CLOSE,
  }),
  save: {
    request: ({ materialId, data }) => ({
      type: types.MATERIAL_MODAL_SAVE_REQUEST,
      payload: { materialId, data },
    }),
    success: ({ supplierMaterial }) => ({
      type: types.MATERIAL_MODAL_SAVE_SUCCESS,
      payload: { supplierMaterial },
    }),
    error: () => ({
      type: types.MATERIAL_MODAL_SAVE_ERROR,
    }),
  },
};
